import { CurrencyService } from "../services/CurrencyService";
import { TrvCryptoService } from "../services/TrvCryptoService";
import { formatMoney, formatPercent } from "../utils/formatters";

const variationClass = (value: number) =>
  value > 0
    ? "cripto-price-row-variation-up"
    : "cripto-price-row-variation-down";

export class CryptoPrice {
  private wrapper: JQuery<HTMLElement>;
  private $viewMore: JQuery<HTMLElement>;
  private $viewPage: JQuery<HTMLElement>;
  private data: CryptoPriceData[] = [];
  private size: number = 5;
  private pointer: number = 0;
  private rowTemplate: JQuery<HTMLElement>;
  private static readonly LOADING_CLASS = "cripto-price-loading";

  constructor() {
    this.wrapper = $(".cripto-price-module-wrapper");
    this.rowTemplate = this.wrapper.find(".cripto-price-row-template");
    this.$viewPage = this.wrapper.find(".cripto-price-view-button");
    this.$viewMore = this.wrapper.find(".cripto-price-more-button");

    if (window.location.pathname.indexOf("crypto-price") > -1) {
      this.size = 10;
    }

    this.getData();
    this.bindEvents();
    this.initWidget();
  }

  private createCards(data: CryptoPriceData[]) {
    const cardTemplate = $('script[id="cripto-card-template"]').text();
    if (!cardTemplate) {
      return;
    }
    const $cardModel = $(cardTemplate);

    const $items = data.map((item) => {
      const $card = $cardModel.clone();
      $card.find(".cripto-card-name").html(item.name);

      const price = item.priceFoxbit
        ? formatMoney(item.priceFoxbit)
        : formatMoney(item.priceExternal);
      $card
        .find(".cripto-card-price")
        .html("<span>R$</span>" + (price || "").split("R$")[1]);
      $card.addClass(item.priceFoxbit ? "show-trade-button" : "");

      $card
        .find(".cripto-card-icon")
        .html($("<img>", { src: item.icon, alt: item.name })[0]);

      $card.find(".cripto-card-percent").append(
        $("<span>", {
          class: variationClass(item.priceChange24hPercent),
          html: formatPercent(item.priceChange24hPercent),
        })
      );

      $card
        .find(".cripto-card-grahp")
        .html(
          $("<img>", { src: item.chart7dUrl, alt: item.name }).addClass(
            item.priceChange7dPercent > 0
              ? "cripto-price-graph-img-green"
              : "cripto-price-graph-img-red"
          )[0]
        );

      return $card;
    });

    $("#cripto-price-top-10-module-cards").html($items as any);
  }

  private async getData() {
    const tbody = this.wrapper.find(".cripto-price-table tbody");

    if (!tbody.length) {
      return false;
    }

    this.wrapper.addClass(CryptoPrice.LOADING_CLASS);
    this.data = await TrvCryptoService.getCrypoPrice(this.pointer, this.size);
    if (this.data.length && this.pointer === 0) {
      this.createCards(this.data);
    }

    const rows = this.data.map((item) => {
      const $tr = $("<tr>", { html: this.rowTemplate.html() });

      if (item.priceFoxbit) {
        $tr.find(".cripto-price-foxbit").addClass("cripto-price-visible");
        $tr
          .find(".cripto-price-foxbit .cripto-price-row-value")
          .html(formatMoney(item.priceFoxbit)!!);
      }

      $tr.find(".cripto-price-row-id").html(item.rank.toString());
      $tr
        .find(".cripto-price-name-group")
        .prepend($("<img>", { src: item.icon }));
      $tr.find(".cripto-price-row-name").html(item.name);
      $tr.find(".cripto-price-row-initials").html(item.symbol);
      $tr
        .find(".cripto-price-external .cripto-price-row-value")
        .html(formatMoney(item.priceExternal)!!);

      $tr
        .find(".cripto-price-table-variation-short")
        .html("")
        .append(
          $("<span>", {
            class: variationClass(item.priceChange24hPercent),
            html: formatPercent(item.priceChange24hPercent),
          })
        );

      $tr
        .find(".cripto-price-table-variation-medium")
        .html("")
        .append(
          $("<span>", {
            class: variationClass(item.priceChange7dPercent),
            html: formatPercent(item.priceChange7dPercent),
          })
        );

      $tr
        .find(".cripto-price-graph-img")
        .attr("src", item.chart7dUrl)
        .addClass(
          item.priceChange7dPercent > 0
            ? "cripto-price-graph-img-green"
            : "cripto-price-graph-img-red"
        );
      $tr
        .find(".cripto-price-row-volume-money")
        .html(formatMoney(item.volume24hCurrency)!!);
      $tr
        .find(".cripto-price-row-volume-cripto")
        .html(formatMoney(item.volume24h, item.symbol)!!);
      $tr
        .find(".cripto-price-row-market-cap")
        .html(formatMoney(item.marketCap, item.symbol)!!);

      return $tr;
    });

    if (this.pointer === 0) {
      tbody.html("");
    }
    tbody.append(rows);

    if (window.location.pathname.indexOf("crypto-price") > -1) {
      this.$viewMore.css({ display: "block" });
    } else {
      this.$viewPage.css({ display: "block" });
    }
    this.wrapper.removeClass(CryptoPrice.LOADING_CLASS);
  }

  private bindEvents() {
    this.wrapper
      .find(".cripto-price-advanced-icon")
      .on("click", this.onAdvancedIconClick.bind(this));

    this.$viewMore.on("click", (e) => {
      e.preventDefault();
      this.pointer += this.size;
      this.getData();
    });
  }

  private onAdvancedIconClick(event: JQuery.ClickEvent) {
    event.preventDefault();

    this.toggleWidget();
  }

  private toggleWidget() {
    this.wrapper
      .find(".cripto-price-widget")
      .toggleClass("cripto-price-widget-open");
  }

  private async initWidget() {
    const currency = await CurrencyService.getSelected();
    if (!currency?.code) {
      document.querySelector(".cripto-price-advanced-icon")?.remove();
      return;
    }
    window.itb_widget = window.itb_widget || {
      init: (t) => {
        const e = document.createElement("script");
        (e.async = !0),
          (e.type = "text/javascript"),
          (e.src = "https://app.intotheblock.com/widget.js"),
          (e.onload = function () {
            window.itbWidgetInit(t);
          }),
          document.getElementsByTagName("head")[0].appendChild(e);
      },
    };
    window.itb_widget.init({
      apiKey: "N0r0TiYuhG5iz1ktM3fCe3XaAPeo51EL4qCoPWNM",
      language: "pt_BR",
      options: {
        tokenId: currency?.code,
        loader: true,
      },
    });
  }
}
